import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getCompanyInfo } from '../services/api';
import { FacebookIcon, InstagramIcon, LinkedInIcon } from './Icons';
import './Footer.css';

const Footer = () => {
  const [companyInfo, setCompanyInfo] = useState({});

  useEffect(() => {
    const fetchCompanyInfo = async () => {
      try {
        const data = await getCompanyInfo();
        setCompanyInfo(data);
      } catch (error) {
        console.error('Error fetching company info:', error);
      }
    };
    fetchCompanyInfo();
  }, []);

  // Use alan@svtconsulting.co as default email
  const email = companyInfo.email || 'alan@svtconsulting.co';
  const city = companyInfo.city || 'Cliffside Park';
  const state = companyInfo.state || 'NJ';

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Company Info */}
          <div className="footer-col footer-brand">
            <Link to="/" className="footer-logo">
              <img src="/logo.png" alt="SVT Consulting" className="footer-logo-image" />
            </Link>
            <p className="footer-tagline">
              Professional technology solutions for homes and businesses. Audio/Video, Security, Automation & Software.
            </p>
            <div className="footer-social">
              {companyInfo.facebook && (
                <a href={companyInfo.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                  <FacebookIcon size={20} />
                </a>
              )}
              {companyInfo.instagram && (
                <a href={companyInfo.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                  <InstagramIcon size={20} />
                </a>
              )}
              {companyInfo.linkedin && (
                <a href={companyInfo.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                  <LinkedInIcon size={20} />
                </a>
              )}
            </div>
          </div>

          {/* Services */}
          <div className="footer-col">
            <h4>Services</h4>
            <ul>
              <li><Link to="/services/audio-video">Audio/Video Systems</Link></li>
              <li><Link to="/services/cctv">CCTV & Security</Link></li>
              <li><Link to="/services/automation">Smart Automation</Link></li>
              <li><Link to="/services/software">Software Development</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div className="footer-col">
            <h4>Company</h4>
            <ul>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/portfolio">Portfolio</Link></li>
              <li><Link to="/apps">Our Apps</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/privacy">Privacy Policy</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-col">
            <h4>Contact</h4>
            <ul className="footer-contact">
              <li>
                <a href="tel:+18453043934">(845) 304-3934</a>
              </li>
              <li>
                <a href={`mailto:${email}`}>{email}</a>
              </li>
              <li>
                {city}, {state}
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} SVT Consulting LLC. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
